<template>
  <div class="project-modal">
    <div ref="projectEditModal" class="modal fade" data-bs-backdrop="static" id="projectEditModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" v-draggable-modal>
        <div class="modal-content bg-primary">

          <div class="modal-header">
            <div class="h5 modal-title text-light me-2"> {{ modalTitle }} </div>
            <DocsInfoLink color="light" target="createProject"></DocsInfoLink>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>

          <div class="modal-body bg-light">
            <div v-if="elementType === 'project'" class="form-link">
              <div v-if="mode === 'add'" class="form-link">
                <div class="mb-3">
                  <div class="form-check form-switch">
                    <input v-model="form.project.folder.content" type="checkbox" role="switch" id="projectFolderCheck" class="form-check-input" :checked="form.project.folder.content">
                    <label for="projectFolderCheck" class="form-check-label">{{ $t("views.project.edit.folder") }}</label>
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <label for="projectParentId" class="form-label">{{ $t("views.project.edit.parentProject") }}</label>
                <select v-model="form.project.parentId.content" id="projectParentId" class="form-select">
                  <option value="" :disabled="!isAdmin">{{ $t("views.project.edit.noParentProject") }}</option>
                  <option v-for="project in projectsList" :key="project.id" :value="project.id" :disabled="mode === 'update' && project.id === selectedProject.id ? true : false">
                    {{ project.name }}
                  </option>
                </select>
              </div>
              <div class="mb-3">
                <label for="projectName" class="form-label">{{ $t("views.project.edit.name") }}<span class="text-danger">*</span></label>
                <input v-model="form.project.name.content" id="projectName" :class="form.project.name.error === '' ? 'form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.project.name.error }}</div>
              </div>
              <div class="mb-3">
                  <label for="projectDescription" class="form-label">{{ $t("views.project.edit.description") }}</label>
                  <RTEditor ref="projectDescription" v-model="form.project.description.content" contentType="html" id="projectDescription"></RTEditor>
                  <div class="quill-invalid-feedback">{{ form.project.description.error }}</div>
              </div>
              <div v-if="!form.project.folder.content" class="row mt-3">
                <div class="row mb-3">
                  <div class="col-6">
                    <label for="projectValidFrom" class="form-label">{{ $t("views.project.edit.validFrom") }}<span class="text-danger">*</span></label>
                    <input v-model="form.project.validFrom.content" type="date" id="projectValidFrom" :class="form.project.validFrom.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.project.validFrom.error }}</div>
                  </div>
                  <div class="col-6">
                    <label for="projectValidTo" class="form-label">{{ $t("views.project.edit.validTo") }}<span class="text-danger">*</span></label>
                    <input v-model="form.project.validTo.content" type="date" id="projectValidTo" :class="form.project.validTo.error === '' ? 'form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.project.validTo.error }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="elementType === 'member'" class="form-org-unit">
              <div class="row mb-3">
                <div class="col">
                  <label for="existingEmployees" class="form-label">{{ $t("views.org.edit.selectEmployee") }}<span class="text-danger">*</span></label>
                  <select v-model="form.member.employeeId.content" class="form-select" id="existingEmployees" :disabled="mode === 'update'" :class="form.member.employeeId.error === '' ? ' form-control' : 'form-control is-invalid'">
                    <option v-for="person in employees" :key="person.id" :value="person.id">
                      {{ person.lastName }}, {{ person.firstName }}
                    </option>
                  </select>
                  <div class="invalid-feedback">{{ form.member.employeeId.error }}</div>
                </div>
              </div>
              <div class="row mb-3">
                <div class="col">
                  <label for="role" class="form-label">{{ $t("general.role") }}<span class="text-danger">*</span></label>
                  <select v-model="form.member.role.content" class="form-select" id="role" :class="form.member.role.error === '' ? ' form-control' : 'form-control is-invalid'">
                    <option value="+" class="bg-custom-blue">{{ $t("general.addRole") }} </option>
                    <option v-for="role in roles" :key="role.id" :value="role">
                      {{ role }}
                    </option>
                  </select>
                  <div class="invalid-feedback">{{ form.member.role.error }}</div>
                  <div v-if="addRole">
                    <input v-model="form.member.newRole.content" type="text" id="newRole" :class="form.member.newRole.error === '' ? ' form-control' : 'form-control is-invalid'">
                    <div class="invalid-feedback">{{ form.member.newRole.error }}</div>
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input" type="checkbox" id="leadIndicator" v-model="form.member.leadIndicator.content">
                    <label class="form-check-label" for="leadIndicator">{{ $t("general.headof") }}</label>
                    <div v-if="form.member.leadIndicator.error" class="invalid-feedback d-block">
                      {{ form.member.leadIndicator.error }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="elementType === 'review'" class="form-link">
              <div class="mb-3">
                <label for="reviewDate" class="form-label">{{ $t("views.project.edit.reviewDate") }}<span class="text-danger">*</span></label>
                <input v-model="form.review.date.content" type="date" id="reviewDate" :class="form.review.date.error === '' ? 'form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.review.date.error }}</div>
              </div>
              <div class="mb-3">
                <label for="reviewAssessment" class="form-label">{{ $t("views.project.edit.reviewAssessment") }}<span class="text-danger">*</span></label>
                <RTEditor ref="reviewAssessment" v-model="form.review.assessment.content" contentType="html" id="reviewAssessment"></RTEditor>
                <div class="quill-invalid-feedback">{{ form.review.assessment.error }}</div>
              </div>
              <div class="mb-3">
                <label for="reviewConversion" class="form-label">{{ $t("views.project.edit.reviewConversion") }}<span class="text-danger">*</span></label>
                <select v-model="form.review.conversion.content" id="reviewConversion" :class="form.review.conversion.error === '' ? 'form-select' : 'form-select is-invalid'">
                  <option value="0">0%</option>
                  <option value="1">25%</option>
                  <option value="2">50%</option>
                  <option value="3">75%</option>
                  <option value="4">100%</option>
                </select>
                <div class="invalid-feedback">{{ form.review.conversion.error }}</div>
              </div>
              <div class="mb-3">
                <label for="reviewPrediction" class="form-label">{{ $t("views.project.edit.reviewPrediction") }}<span class="text-danger">*</span></label>
                <select v-model="form.review.prediction.content" id="reviewPrediction" :class="form.review.prediction.error === '' ? 'form-select' : 'form-select is-invalid'">
                  <option value="Y">{{ $t("views.project.detail.review.prediction.y") }}</option>
                  <option value="D">{{ $t("views.project.detail.review.prediction.d") }}</option>
                  <option value="N">{{ $t("views.project.detail.review.prediction.n") }}</option>
                </select>
                <div class="invalid-feedback">{{ form.review.prediction.error }}</div>
              </div>
            </div>
            <div v-if="elementType === 'measure'" class="form-link">
              <div class="mb-3">
                <label for="measureTitle" class="form-label">{{ $t("views.project.edit.measureTitle") }}<span class="text-danger">*</span></label>
                <input v-model="form.measure.title.content" id="measureTitle" :class="form.measure.title.error === '' ? 'form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.measure.title.error }}</div>
              </div>
              <div class="mb-3">
                <label for="measureMeasure" class="form-label">{{ $t("views.project.edit.measureDescription") }}<span class="text-danger">*</span></label>
                <RTEditor ref="measureMeasure" v-model="form.measure.measure.content" contentType="html" id="measureMeasure"></RTEditor>
                <div class="quill-invalid-feedback">{{ form.measure.measure.error }}</div>
              </div>
              <div class="mb-3">
                <label for="measureResponsible" class="form-label">{{ $t("views.project.edit.measureResponsible") }}<span class="text-danger">*</span></label>
                <select v-model="form.measure.responsible.content" id="measureResponsible" :class="form.measure.responsible.error === '' ? 'form-select' : 'form-select is-invalid'">
                  <option v-for="member in employees" :key="member.id" :value="member.id">
                    {{ member.lastName }}, {{ member.firstName }}
                  </option>
                </select>
                <div class="invalid-feedback">{{ form.measure.responsible.error }}</div>
              </div>
              <div class="mb-3">
                <label for="measureConversion" class="form-label">{{ $t("views.project.edit.measureConversion") }}</label>
                <select v-model="form.measure.conversion.content" id="measureConversion" :class="form.measure.conversion.error === '' ? 'form-select' : 'form-select is-invalid'">
                  <option value="0">0%</option>
                  <option value="1">25%</option>
                  <option value="2">50%</option>
                  <option value="3">75%</option>
                  <option value="4">100%</option>
                </select>
                <div class="invalid-feedback">{{ form.measure.conversion.error }}</div>
              </div>
              <div class="mb-3">
                <label for="measureValidFrom" class="form-label">{{ $t("views.project.edit.measureValidFrom") }}<span class="text-danger">*</span></label>
                <input v-model="form.measure.validFrom.content" type="date" id="measureValidFrom" :class="form.measure.validFrom.error === '' ? 'form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.measure.validFrom.error }}</div>
              </div>
              <div class="mb-3">
                <label for="measureValidTo" class="form-label">{{ $t("views.project.edit.measureValidTo") }}<span class="text-danger">*</span></label>
                <input v-model="form.measure.validTo.content" type="date" id="measureValidTo" :class="form.measure.validTo.error === '' ? 'form-control' : 'form-control is-invalid'">
                <div class="invalid-feedback">{{ form.measure.validTo.error }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-light justify-content-between">
            <div>
              <button v-if="elementType === 'project'" type="button" class="btn btn-sm btn-outline-danger" :class="selectedProject.hasNodes ? 'disabled' : ''" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#projectDeleteModal">{{ $t("general.delete") }}</button>
            </div>
            <div>
              <button type="button" class="btn btn-sm btn-outline-secondary me-2" data-bs-dismiss="modal">{{ $t("general.close") }}</button>
              <button @click="save()" type="button" class="btn btn-sm btn-primary">{{ $t("general.save") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import initializeForm from '../../composables/initializeForm'
import setFormContent from '../../composables/setFormContent'
import * as validation from '../../composables/validation'
import DocsInfoLink from '../../components/DocsInfoLink.vue'
import RTEditor from '../RTEditor.vue'
import { Modal } from 'bootstrap'
import { ref } from 'vue'
import { i18n } from '../../i18n'

export default {
  name: 'ProjectEditModal',
  mounted () {
    const myModalDialog = document.getElementById('projectEditModal')

    myModalDialog.addEventListener('shown.bs.modal', event => {
      const mode = this.$parent.projectModalMode
      if (mode === 'add') {
        initializeForm(this.form.project)
        initializeForm(this.form.member)
        initializeForm(this.form.review)
        initializeForm(this.form.measure)
        this.form.project.parentId.content = this.$store.state.selectedProject.id
        const today = new Date().toISOString().substring(0, 10)
        this.form.review.date.content = today
      }
      if (mode === 'update') {
        this.oldRoleContent = this.form.member.role.content
      }
    })
    myModalDialog.addEventListener('hidden.bs.modal', event => {
      const mode = this.$parent.projectModalMode
      if (mode !== 'add' && mode !== 'delete') {
        setFormContent(this.form, this.$store.state.selectedProject, 'project', this.elementType, this.$parent.projectModalElementId)
      }
    })
  },
  data () {
    return {
      oldRoleContent: '',
      form: {
        project: {
          folder: {
            content: '',
            error: '',
            validate: []
          },
          parentId: {
            content: '',
            error: '',
            validate: []
          },
          name: {
            content: '',
            error: '',
            maxLength: 255,
            validate: ['empty', 'length']
          },
          description: {
            content: '',
            error: '',
            validate: [],
            rtEditor: true,
            ref: 'projectDescription'
          },
          responsible: {
            content: '',
            error: '',
            validate: []
          },
          validFrom: {
            content: '',
            error: '',
            validate: ['empty', 'validFrom']
          },
          validTo: {
            content: '',
            error: '',
            validate: ['empty', 'validTo']
          }
        },
        member: {
          employeeId: {
            content: '',
            error: '',
            validate: ['empty']
          },
          role: {
            content: '',
            error: '',
            validate: ['empty']
          },
          newRole: {
            content: '',
            error: '',
            validate: []
          },
          leadIndicator: {
            content: '',
            error: '',
            validate: []
          }
        },
        review: {
          date: {
            content: '',
            error: '',
            validate: ['empty']
          },
          assessment: {
            content: '',
            error: '',
            validate: ['empty'],
            rtEditor: true,
            ref: 'reviewAssessment'
          },
          conversion: {
            content: '',
            error: '',
            validate: ['empty']
          },
          prediction: {
            content: '',
            error: '',
            validate: ['empty']
          }
        },
        measure: {
          title: {
            content: '',
            error: '',
            maxLength: 255,
            validate: ['empty', 'length']
          },
          measure: {
            content: '',
            error: '',
            validate: ['empty'],
            rtEditor: true,
            ref: 'measureMeasure'
          },
          responsible: {
            content: '',
            error: '',
            validate: ['empty']
          },
          conversion: {
            content: '',
            error: '',
            validate: []
          },
          validFrom: {
            content: '',
            error: '',
            validate: ['empty', 'validFrom']
          },
          validTo: {
            content: '',
            error: '',
            validate: ['empty', 'validTo']
          }
        }
      }
    }
  },
  components: {
    DocsInfoLink,
    RTEditor
  },
  computed: {
    selectedProject () {
      return this.$store.state.selectedProject
    },
    projectsList () {
      return this.$store.state.projectsList
    },
    roles () {
      return this.$store.state.selectedProject.roles
    },
    employees () {
      return this.$store.state.employees
    },
    elementId () {
      return this.$parent.projectModalElementId
    },
    elementType () {
      return this.$parent.projectModalElementType
    },
    mode () {
      return this.$parent.projectModalMode
    },
    addRole () {
      if (this.form.member.role.content === '+') {
        return true
      } else {
        return false
      }
    },
    isAdmin () {
      return this.$store.state.user.role === 10387
    },
    modalTitle () {
      const titles = {
        project: {
          add: this.$t('views.project.edit.headingAddProject'),
          update: this.$t('views.project.edit.headingEditProject')
        },
        review: {
          add: this.$t('views.project.edit.headingAddReview'),
          update: this.$t('views.project.edit.headingEditReview')
        },
        measure: {
          add: this.$t('views.project.edit.headingAddMeasure'),
          update: this.$t('views.project.edit.headingEditMeasure')
        },
        member: {
          add: this.$t('views.project.edit.headingAddMember'),
          update: this.$t('views.project.edit.headingEditMember')
        }
      }
      return titles[this.elementType]?.[this.mode] ?? ''
    }
  },
  methods: {

    async save () {
      this.$store.commit('SET_LOADING_STATUS', true)

      if (this.form.project.folder.content) {
        this.form.project.validFrom.content = '2000-01-01'
        this.form.project.validTo.content = '2099-12-31'
      }

      let valid = 0
      if (this.elementType === 'project') valid = validation.fieldValidation(this.form.project)
      if (this.elementType === 'member') {
        if (this.form.member.role.content === '+') {
          this.form.member.newRole.validate[0] = 'empty'
          this.form.member.role.content = this.form.member.newRole.content
        } else {
          this.form.member.newRole.validate = []
          this.form.member.newRole.content = ''
        }
        valid = validation.fieldValidation(this.form.member)
        // Check if member is already assigned to this project
        if (this.$parent.projectModalMode === 'update' && this.oldRoleContent === this.form.member.role.content) {
          // do nothing
        } else {
          const exists = this.$store.state.selectedProject.members.some(m => (m.employeeId === this.form.member.employeeId.content && m.role === this.form.member.role.content))
          if (exists) {
            valid++
            this.form.member.employeeId.error = i18n?.global.t('error.5032', this.$store.state.user.settings.language)
          }
        }

        // Check leadIndicator may be set only once
        const wantsLead = this.form.member.leadIndicator.content === true
        if (wantsLead && this.$store.state.selectedProject.members.some(m => m.leadIndicator === true)) {
          valid++
          this.form.member.leadIndicator.error = i18n?.global.t('error.5033', this.$store.state.user.settings.language)
        }
      }
      if (this.elementType === 'review') valid = validation.fieldValidation(this.form.review)
      if (this.elementType === 'measure') valid = validation.fieldValidation(this.form.measure)

      if (valid === 0) {
        Object.keys(this.form[this.elementType]).forEach(field => {
          if (this.form[this.elementType][field].rtEditor) {
            const ref = this.form[this.elementType][field].ref
            if (this.$refs[ref]) {
              this.form[this.elementType][field].content = this.$refs[ref].getContent()
            }
          }
        })
        const elementData = Object.assign(
          ...Object.entries(this.form[this.elementType]).map(([key, value]) => ({ [key]: value.content }))
        )
        if (elementData.parentId === undefined) elementData.parentId = ''
        if (elementData.folder === '') elementData.folder = 'false'

        elementData.id = this.elementId
        let dispatchFunc = ''
        if (this.elementType !== 'project') {
          elementData.elementType = (this.elementType + 's')
          elementData.projectId = this.selectedProject.id
        }
        dispatchFunc = this.elementType === 'project' ? (this.mode + 'Project') : (this.mode + 'ProjectElement')
        await this.$store.dispatch(dispatchFunc, elementData).then(() => {
          this.closeModal()
        })
      }

      this.$store.commit('SET_LOADING_STATUS', false)

      // Reload Data & Treeview
      if (this.elementType === 'project' || this.elementType === 'review') {
        await this.$store.dispatch('getProjects', { validFrom: this.$parent.filterValidFrom, validTo: this.$parent.filterValidTo })
      }
    },
    updateModalContent () {
      setFormContent(this.form, this.elementType, this.$store.state.selectedProject, 'project')
    }
  },
  watch: {
    elementId () {
      const mode = this.$parent.projectModalMode
      if (mode === 'update') {
        setFormContent(this.form, this.$store.state.selectedProject, 'project', this.elementType, this.$parent.projectModalElementId)
      }
    },
    mode (newMode) {
      if (newMode === 'update') {
        setFormContent(this.form, this.$store.state.selectedProject, 'project', this.elementType, this.$parent.projectModalElementId)
      }
    }
  },
  setup () {
    const projectEditModal = ref(null)
    const closeModal = () => Modal.getInstance(projectEditModal.value)?.hide()
    return { projectEditModal, closeModal }
  }
}
</script>
